module.exports = __webpack_public_path__ + "img/logo.887cf919.png";